<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240);background: #ffffff"
      title="商品灵感"
      :breadcrumb=" { props: { routes:[{path:'/',breadcrumbName:$t('HOME')}

      ,{path:`/goods-inspiration/${goodsId}`,breadcrumbName:'商品灵感'}
      ] } }"
    />
    <div style="position: relative">
      <a-menu :defaultSelectedKeys="['goods']" mode="horizontal">
        <a-menu-item
          key="goods"
          :disabled="!goodsId"
        >
          <a-icon type="appstore"/>
          相关灵感
        </a-menu-item>
      </a-menu>
      <a-space style="position: absolute;right: 8px;top: 8px;">
        <a-button type="primary" @click="addInspiration">
          {{ $t('ADD') || '添加' }}
        </a-button>
        <a-button @click="onCancel">
          {{ $t('BACK') || '返回' }}
        </a-button>
      </a-space>
    </div>
    <a-spin :spinning="form.loading">
      <div style="margin: 16px">
        <a-card>
          <a-table
            row-key="id"
            :data-source="table.data"
            ref="dragTable"
            :pagination="false"
            :columns="table.columns"
          >
            <span slot="inspirationImg" slot-scope="text, record">
               <a-avatar :size="50" shape="square" :src="record.inspirationImg"/>
            </span>
            <span slot="videoCover" slot-scope="text, record">
               <a-avatar :size="50" shape="square" :src="record.videoCover"/>
            </span>
            <template slot="sort">
              <a-icon type="drag"  style="font-size: 25px;"/>
            </template>
            <template slot="action" slot-scope="text, record">
              <a-button type="link" @click="editInspiration(record.id)">{{ $t('EDIT') || '编辑' }}</a-button>
              <a-button type="link" @click="deleteInspiration(record.id)">{{ $t('DELETE') || '删除' }}</a-button>
             </template>
          </a-table>
        </a-card>
      </div>
    </a-spin>
    <a-modal
      :footer="null"
      append-to-body
      :title="$t('PREVIEW')||'预览'"
      v-model="form.visible">
      <goods-inspiration-edit
        v-if="form.visible"
        :inspiration-id="form.data.id"
        :goods-id="this.goodsId"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm"
      />
    </a-modal>
  </div>
</template>

<script>
import {
  _queryInspirationByGoodsId,
  _deleteInspiration,
  _updateGoodsSort,
} from '@/api/goodsInspirationApi';
import GoodsInspirationEdit from '@/views/shop/goods/GoodsInspirationEdit.vue';
import Sortable from 'sortablejs';

async function initData() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryInspirationByGoodsId({
    goodsId: this.goodsId,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.query.total = result.totalElements;
}

function onCancel() {
  this.$router.go(-1);
}

function addInspiration() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editInspiration(id) {
  this.form.data.id = id;
  this.form.visible = true;
}

function deleteInspiration(id) {
  this.$confirm({
    title: '是否删除',
    content: '',
    onOk: async () => {
      await _deleteInspiration(id);
      this.$message.success('删除成功');
      this.initData();
    },
  });
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.initData();
}

async function updateSortList(oldIndex, newIndex) {
  const idStr = this.table.data.map(x => x.id).join(',')
  const sortStr = this.table.data.map(x => x.sort).join(',')
  const result = await _updateGoodsSort({
    idStr,
    sortStr,
    oldIndex,
    newIndex
  })
  if (result) {
    this.$message.success('移动排序成功')
    await this.initData();
  }
}

function initSortable() {
  const el = this.$refs.dragTable.$el.querySelector('.ant-table-tbody')
  const dragTable = Sortable.create(el, {
    handle: 'td:nth-child(4)',
    animation: 150,
    // 利用更新
    onUpdate: (e) => {
      const oldIndex = e.oldIndex
      const newIndex = e.newIndex
      if (oldIndex === newIndex) {
        return
      }
      this.updateSortList(oldIndex, newIndex)
    },
  })
}

const columns = [
  {
    title: '类型',
    dataIndex: 'type',
  },
  {
    title: '图片封面',
    dataIndex: 'inspirationImg',
    scopedSlots: { customRender: 'inspirationImg' },
  },
  {
    title: '视频封面',
    dataIndex: 'videoCover',
    scopedSlots: { customRender: 'videoCover' },
  },
  {
    title: '拖拽排序',
    dataIndex: 'id',
    align: 'center',
    scopedSlots: { customRender: 'sort' },
  },
  {
    title: '操作',
    width: 300,
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'GoodsInspirationList',
  components: { GoodsInspirationEdit },
  props: {
    goodsId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    goodsId() {
      if (this.goodsId) {
        this.initData();
      }
    },
  },
  methods: {
    onCancel,
    initData,
    addInspiration,
    editInspiration,
    deleteInspiration,
    closeForm,
    initSortable,
    updateSortList,
  },
  data() {
    return {
      topic: {
        data: [],
      },
      table: {
        columns,
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descending',
        },
      },
      form: {
        loading: false,
        visible: false,
        data: {
          id: '',
        },
        rules: {
          name: [{
            required: true,
            trigger: 'blur',
          }],
          type: [{
            required: true,
            trigger: 'blur',
          }],
          topicId: [{
            required: true,
            trigger: 'blur',
          }],
        },
        title: '',
      },
    };
  },
  mounted() {
    this.initSortable();
  },
  async created() {
    if (this.goodsId) {
      await this.initData();
    }
  },
};
</script>
